// extracted by mini-css-extract-plugin
export default {"overlay":"AreYouSure_overlay__MnDjz","modal":"AreYouSure_modal__i-hZ6","iconWrap":"AreYouSure_iconWrap__lxhHP","actions":"AreYouSure_actions__wyZhT"};